import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';

const SearchResultRowWithIndicator = ({
  children,
  Icon,
  color = 'primary',
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '5px 0px',
      }}
    >
      <div
        style={{
          display: 'inherit',
          width: '5%',
        }}
      >
        {Icon && <Icon color={color} fontSize='small' />}
      </div>
      <div
        style={{
          display: 'inline-block',
          width: '95%',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default SearchResultRowWithIndicator;
